<template>
  <v-app-bar
    app
    bottom
    style="z-index: 1999; height: 80px"
    class="pt-2"
    :style="
      getTheme() == 'dark'
        ? 'border-top: 1px solid darkgray; background-color: #303030'
        : 'border-top: 1px solid lightgray; background-color: white; elevation-0'
    "
  >
    <v-spacer></v-spacer>
    <v-btn
      text
      :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
      to="/userCart"
    >
      <v-badge
        v-if="$store.state.storeCart.cart.length > 0"
        class="animated bounce"
        style="animation-delay: 8s"
        color="error"
        left
      >
        <template v-slot:badge>
          {{ $store.state.storeCart.cart.length }}
        </template>
        <v-icon>mdi-cart</v-icon>
        <span class="ml-1">{{ $t("homeMenuCartInfoCartTitle") }}</span>
      </v-badge>
      <div v-else>
        <v-icon>mdi-cart</v-icon>
        <span class="ml-1">{{ $t("homeMenuCartInfoCartTitle") }}</span>
      </div>
    </v-btn>

    <v-btn
      text
      :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
      class="ml-2"
      to="/userOrders"
    >
      <v-badge
        v-if="
          $store.state.storeOrders.orders.filter((x) =>
            statusItems.includes(x.status.toString())
          ).length > 0
        "
        class="animated bounce"
        style="animation-delay: 9s"
        color="error"
        left
      >
        <template v-slot:badge>
          {{
            $store.state.storeOrders.orders.filter((x) =>
              statusItems.includes(x.status.toString())
            ).length
          }}
        </template>
        <v-icon>mdi-image-search-outline</v-icon>
        <span class="ml-1">{{ $t("homeMenuCartInfoOrderStatusTitle") }}</span>
      </v-badge>
      <div v-else>
        <v-icon>mdi-image-search-outline</v-icon>
        <span class="ml-1">{{ $t("homeMenuCartInfoOrderStatusTitle") }}</span>
      </div>
    </v-btn>
    <v-spacer></v-spacer>

    <!-- CHAT BUTTON -->
    <v-dialog v-model="overlay2" max-width="400px">
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          medium
          color="secondary"
          v-on="on"
          @click="overlay2 = !overlay2"
          v-show="
            $store.state.storeClient.client.modules.moduleModerator.active &&
            (($store.state.storeAuth.userProfile.isModerator &&
              $store.state.storeRoom.rooms.length > 0) ||
              !$store.state.storeAuth.userProfile.isModerator)
          "
          absolute
          fixed
          right
          top
        >
          <v-badge
            v-if="$store.state.storeRoom.rooms.length > 0"
            color="success"
            right
          >
            <template v-slot:badge>
              {{ $store.state.storeRoom.rooms.length }}
            </template>
            <v-icon medium color="white">mdi-message-text</v-icon>
          </v-badge>
          <v-icon v-else medium color="white">mdi-message-text</v-icon>
        </v-btn>
      </template>
      <!-- ACTIVE CONVERSATIONS BUTTONS-->
      <v-list
        style="text-align: left"
        class="py-0"
        v-if="$store.state.storeAuth.userProfile.isModerator"
      >
        <v-subheader class="secondary white--text overline justify-center">
          {{ $t("homeMenuCartInfoActiveUserRoomsTitle") }}
        </v-subheader>
        <v-item-group color="secondary">
          <v-list-item
            v-for="(item, index) in $store.state.storeRoom.rooms"
            :key="index"
          >
            <v-dialog
              v-model="chatModeratorWindow"
              scrollable
              persistent
              :retain-focus="false"
              max-width="500px"
              :fullscreen="$vuetify.breakpoint.xsOnly"
              transition="dialog-bottom-transition"
            >
              <template v-slot:activator="{ on }" justify="right">
                <div
                  v-on="on"
                  @click="startChatModeratorWindow(item)"
                  class="d-flex flex-no-wrap"
                >
                  <v-list-item-icon>
                    <v-badge color="success" icon="mdi-comment-text">
                      <v-icon color="secondary">mdi-forum</v-icon>
                    </v-badge>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.userFullName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </div>
              </template>
              <v-card>
                <v-card-title>
                  <v-icon color="primary" class="mr-2">{{ chat.icon }}</v-icon>
                  {{ chat.recipient }}
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    fab
                    small
                    @click="chatModeratorWindow = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-title class="pa-0 ma-0 px-2">
                  <v-text-field
                    class="pl-4 mb-2"
                    v-model="chat.message"
                    :label="$t('homeMenuCartInfoSendMessageTitle')"
                    :rules="[validateMaxLength(250)]"
                    :counter="250"
                    v-on:keyup.enter="handleModeratorEnter"
                  ></v-text-field>
                  <v-btn
                    text
                    color="primary"
                    fab
                    large
                    @click="handleModeratorEnter"
                  >
                    <v-icon>mdi-send</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text class="ma-0 pa-0">
                  <div class="px-4">
                    <div
                      style="background-color: whitesmoke"
                      class="pa-2 overflow-y-auto"
                    >
                      <div
                        v-for="(
                          room, index
                        ) in $store.state.storeRoom.rooms.filter(
                          (x) =>
                            x.chatMembers.includes(chat.recipientId) &&
                            x.chatMembers.includes(
                              $store.state.storeAuth.user.uid
                            )
                        )"
                        :key="index"
                      >
                        <div
                          class="px-1 py-1"
                          v-for="(message, i) in room.messages"
                          :key="i"
                        >
                          <div
                            v-if="message.customer"
                            class="accent pa-2"
                            style="color: white; border-radius: 10px / 25%"
                          >
                            <v-icon small color="white" class="mr-1"
                              >mdi-face</v-icon
                            >
                            <span class="mr-1"
                              >[{{ getChatTime(message.timestamp) }}]</span
                            >
                            {{ message.text }}
                          </div>
                          <div
                            v-else
                            class="primary pa-2"
                            style="color: white; border-radius: 10px / 25%"
                          >
                            <v-icon small color="white" class="mr-1"
                              >mdi-camera</v-icon
                            >
                            <span class="mr-1"
                              >[{{ getChatTime(message.timestamp) }}]</span
                            >
                            {{ message.text }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pt-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="deleteRoom"
                    color="secondary"
                    dark
                    class="mb-2"
                  >
                    <v-icon medium class="mr-1">mdi-broom</v-icon>
                    {{ chat.closeButtonText }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-item>
        </v-item-group>
      </v-list>

      <!-- MODERATORS ONLINE BUTTONS-->
      <v-list v-else style="text-align: left" class="py-0">
        <v-subheader class="secondary white--text overline justify-center">
          {{ $t("homeMenuCartInfoActiveModeratorsTitle") }}
        </v-subheader>

        <v-item-group color="secondary">
          <v-list-item
            v-for="(item, index) in $store.state.storeAuth.moderatorOnline"
            :key="index"
          >
            <v-dialog
              v-model="chatWindow"
              scrollable
              persistent
              :retain-focus="false"
              max-width="500px"
              :fullscreen="$vuetify.breakpoint.xsOnly"
              transition="dialog-bottom-transition"
            >
              <template v-slot:activator="{ on }" justify="right">
                <div
                  v-on="on"
                  @click="startChatWindow(item)"
                  class="d-flex flex-no-wrap"
                >
                  <v-list-item-icon>
                    <v-badge
                      color="success"
                      v-if="
                        $store.state.storeRoom.rooms.filter(
                          (x) => x.chatMembers.includes(item.id) && item.online
                        ).length > 0
                      "
                      icon="mdi-comment-text"
                    >
                      <v-icon v-if="item.online" color="secondary"
                        >mdi-forum</v-icon
                      >
                      <v-icon v-else>mdi-email-send-outline</v-icon>
                    </v-badge>
                    <div v-else>
                      <v-icon v-if="item.online" color="secondary"
                        >mdi-forum</v-icon
                      >
                      <v-icon v-else>mdi-email-send-outline</v-icon>
                    </div>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.fullName }}</v-list-item-title>
                  </v-list-item-content>
                </div>
              </template>
              <v-card>
                <v-card-title>
                  <v-icon color="primary" class="mr-2">{{ chat.icon }}</v-icon>
                  {{ chat.recipient }}
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    fab
                    small
                    @click="chatWindow = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-title v-if="chat.online" class="pa-0 ma-0 px-2">
                  <v-text-field
                    class="pl-4 mb-2"
                    v-model="chat.message"
                    :label="$t('homeMenuCartInfoSendMessageTitle')"
                    :rules="[validateMaxLength(250)]"
                    :counter="250"
                    v-on:keyup.enter="handleEnter"
                  ></v-text-field>
                  <v-btn text color="primary" fab large @click="handleEnter">
                    <v-icon>mdi-send</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text class="ma-0 pa-0">
                  <div v-if="chat.online" class="px-4">
                    <div
                      style="
                        border: 1px solid lightgray;
                        background-color: whitesmoke;
                      "
                      class="pa-2 overflow-y-auto"
                    >
                      <!-- pozdravno sporočilo prikažemo samo doker je manj kot 5 sporočil -->
                      <div
                        v-if="
                          $store.state.storeRoom.rooms.filter(
                            (x) =>
                              x.chatMembers.includes(chat.recipientId) &&
                              x.chatMembers.includes(
                                $store.state.storeAuth.user.uid
                              )
                          ).length == 0 ||
                          $store.state.storeRoom.rooms.find(
                            (x) =>
                              x.chatMembers.includes(chat.recipientId) &&
                              x.chatMembers.includes(
                                $store.state.storeAuth.user.uid
                              )
                          ).messages.length < 5
                        "
                        class="primary pa-2 mx-1 my-1"
                        style="color: white; border-radius: 10px / 25%"
                      >
                        <v-icon small color="white" class="mr-1"
                          >mdi-camera</v-icon
                        >
                        {{ $t("homeMenuCartInfoFirstMessageTitle") }}
                      </div>
                      <div
                        v-for="(
                          room, index
                        ) in $store.state.storeRoom.rooms.filter(
                          (x) =>
                            x.chatMembers.includes(chat.recipientId) &&
                            x.chatMembers.includes(
                              $store.state.storeAuth.user.uid
                            )
                        )"
                        :key="index"
                      >
                        <div
                          class="px-1 py-1"
                          v-for="(message, i) in room.messages"
                          :key="i"
                        >
                          <div
                            v-if="message.customer"
                            class="accent pa-2"
                            style="color: white; border-radius: 10px / 25%"
                          >
                            <v-icon small color="white" class="mr-1"
                              >mdi-face</v-icon
                            >
                            {{ message.text }}
                          </div>
                          <div
                            v-else
                            class="primary pa-2"
                            style="color: white; border-radius: 10px / 25%"
                          >
                            <v-icon small color="white" class="mr-1"
                              >mdi-camera</v-icon
                            >
                            {{ message.text }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <v-textarea
                      append-icon="mdi-comment"
                      class="ma-4"
                      style="height: 200px"
                      rows="6"
                      outlined
                      clearable
                      :label="$t('homeMenuCartInfoSendEmailTitle')"
                      v-model="chat.emailMsg"
                    ></v-textarea>
                  </div>
                </v-card-text>
                <v-card-actions class="pt-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="chat.online"
                    @click="deleteRoom"
                    color="primary"
                    dark
                    class="mb-2"
                  >
                    <v-icon medium class="mr-1">mdi-broom</v-icon>
                    {{ chat.closeButtonText }}
                  </v-btn>
                  <v-btn
                    v-else
                    @click="sendEmailMsg(item)"
                    color="primary"
                    dark
                    class="mb-2"
                  >
                    <v-icon medium class="mr-1">mdi-email-send-outline</v-icon>
                    {{ chat.closeButtonText }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-item>
        </v-item-group>
      </v-list>

      <!--
            <template v-slot:activator="{ on }" justify="right">
              <v-btn
                dark
                medium
                :color="item.online ? 'secondary lighten-1' : '#707B7C'"
                v-on="on"
                @click="startChatWindow(item)"
              >
                <v-icon v-if="item.online" class="mr-2">mdi-forum</v-icon>
                <v-icon v-else class="mr-2">mdi-email-send-outline</v-icon>
                <v-badge
                  v-if="$store.state.storeRoom.rooms.filter(x => x.chatMembers.includes(item.id) && (item.online)).length > 0"
                  color="success"
                  icon="mdi-comment-text"
                >{{ item.fullName }}</v-badge>
                <span v-else>{{ item.fullName }}</span>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <v-icon color="primary" class="mr-2">{{ chat.icon }}</v-icon>
                {{ chat.recipient }}
                <v-spacer></v-spacer>
                <v-btn text color="primary" fab small @click="chatWindow = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-title v-if="chat.online" class="pa-0 ma-0 px-2">
                <v-text-field
                  class="pl-4 mb-2"
                  v-model="chat.message"
                  :label="$t('homeMenuCartInfoSendMessageTitle')"
                  :rules="[validateMaxLength(250)]"
                  :counter="250"
                  v-on:keyup.enter="handleEnter"
                ></v-text-field>
                <v-btn text color="primary" fab large @click="handleEnter">
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="ma-0 pa-0">
                <div v-if="chat.online" class="px-4">
                  <div
                    style="border: 1px solid lightgray; background-color: whitesmoke"
                    class="pa-2 overflow-y-auto"
      >-->
      <!-- pozdravno sporočilo prikažemo samo doker je manj kot 5 sporočil -->
      <!--<div
                      v-if="($store.state.storeRoom.rooms.filter(x => x.chatMembers.includes(chat.recipientId) && x.chatMembers.includes($store.state.storeAuth.user.uid)).length == 0) || ($store.state.storeRoom.rooms.find(x => x.chatMembers.includes(chat.recipientId) && x.chatMembers.includes($store.state.storeAuth.user.uid)).messages.length < 5)"
                      class="primary pa-2 mx-1 my-1"
                      style="color: white; border-radius: 10px / 25%;"
                    >
                      <v-icon small color="white" class="mr-1">mdi-camera</v-icon>
                      {{ $t('homeMenuCartInfoFirstMessageTitle') }}
                    </div>
                    <div
                      v-for="(room, index) in $store.state.storeRoom.rooms.filter(x => x.chatMembers.includes(chat.recipientId) && x.chatMembers.includes($store.state.storeAuth.user.uid))"
                      :key="index"
                    >
                      <div class="px-1 py-1" v-for="(message, i) in room.messages" :key="i">
                        <div
                          v-if="message.customer"
                          class="accent pa-2"
                          style="color: white; border-radius: 10px / 25%;"
                        >
                          <v-icon small color="white" class="mr-1">mdi-face</v-icon>
                          {{ message.text }}
                        </div>
                        <div
                          v-else
                          class="primary pa-2"
                          style="color: white; border-radius: 10px / 25%;"
                        >
                          <v-icon small color="white" class="mr-1">mdi-camera</v-icon>
                          {{ message.text }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <v-textarea
                    append-icon="mdi-comment"
                    class="ma-4"
                    style="height: 200px"
                    rows="6"
                    outlined
                    clearable
                    :label="$t('homeMenuCartInfoSendEmailTitle')"
                    v-model="chat.emailMsg"
                  ></v-textarea>
                </div>
              </v-card-text>
              <v-card-actions class="pt-4">
                <v-spacer></v-spacer>
                <v-btn v-if="chat.online" @click="deleteRoom" color="primary" dark class="mb-2">
                  <v-icon medium class="mr-1">mdi-broom</v-icon>
                  {{ chat.closeButtonText }}
                </v-btn>
                <v-btn v-else @click="sendEmailMsg(item)" color="primary" dark class="mb-2">
                  <v-icon medium class="mr-1">mdi-email-send-outline</v-icon>
                  {{ chat.closeButtonText }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>-->
    </v-dialog>

    <!-- NEW ITEM BUTTON -->
    <!--<v-dialog v-model="overlay" max-width="400px">
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          medium
          color="primary"
          v-on="on"
          @click="overlay = !overlay"
          v-if="
            $store.state.storeClient.client.modules.modulePhotoOrder.active ||
              $store.state.storeClient.client.modules.modulePhotoGift.active ||
              $store.state.storeClient.client.modules.moduleUserSettings.active
          "
          absolute
          fixed
          right
          top
        >
          <v-icon medium color="white">mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-list style="text-align: left;" class="py-0">
        <v-subheader class="primary white--text overline justify-center">{{
          $t("homeMenuCartInfoActionButtonWelcomeTitle")
        }}</v-subheader>
        <v-item-group color="primary">
          <v-list-item
            to="/userNewOrderBasic"
            v-if="
              $store.state.storeClient.client.modules.modulePhotoOrder.active
            "
          >
            <v-list-item-icon>
              <v-icon color="primary">mdi-folder-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("dashboardCardModulePhotoOrderUserSubTitle")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $t("dashboardCardModulePhotoOrderUserOrderButtonTitle")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            to="/userNewPhotoGiftOrder"
            v-if="
              $store.state.storeClient.client.modules.modulePhotoGift.active
            "
          >
            <v-list-item-icon>
              <v-icon color="primary">mdi-folder-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("dashboardCardModulePhotoGiftSubTitle")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $t("dashboardCardModulePhotoGiftOrderButtonTitle")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            to="/userSettings"
            v-if="
              $store.state.storeClient.client.modules.moduleUserSettings.active
            "
          >
            <v-list-item-icon>
              <v-icon color="primary">mdi-settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("dashboardCardUserSettingsTitle")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $t("dashboardCardUserSettingsUpdateButtonTitle")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-item-group>
      </v-list>
    </v-dialog>-->
    <v-snackbar
      v-model="$store.state.storeSnackbar.snackbar.active"
      :color="$store.state.storeSnackbar.snackbar.color"
      :timeout="$store.state.storeSnackbar.snackbar.timeout"
      >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
    >
  </v-app-bar>
</template>

<script>
import firebase from "firebase/app";
import "firebase/functions";
import moment from "moment";

export default {
  name: "homeMenuCartInfo",
  data() {
    return {
      overlay: false,
      overlay2: false,
      dialogWait: false,
      dialogModeratorWait: false,
      statusItems: this.$store.state.storeOrders.statusItems,
      chatWindow: false,
      chatModeratorWindow: false,
      chat: {
        roomId: "",
        online: false,
        message: "",
        recipientId: "",
        recipient: "",
        recipientEmail: "",
        icon: "",
        emailMsg: "",
        closeButtonTxt: "",
      },
    };
  },
  methods: {
    startChatModeratorWindow(item) {
      this.dialogModeratorWait = false;
      this.chat.roomId = item.id;
      this.chat.icon = "mdi-forum";
      this.chat.recipient = item.userFullName;
      this.chat.recipientId = item.userId;
      this.chat.closeButtonText = this.$t(
        "homeMenuCartInfoCloseChatButtonTitle"
      );
      this.chatModeratorWindow = true;
    },
    startChatWindow(item) {
      this.dialogWait = false;
      this.chat.recipientId = item.id;
      this.chat.recipient = item.fullName;
      this.chat.recipientEmail = item.email;
      this.chat.online = item.online;

      try {
        // poskušamo dobiti id sobe, da jo potem lahko izbrišemo
        this.chat.roomId = this.$store.state.storeRoom.rooms.find(
          (x) =>
            x.chatMembers.includes(this.chat.recipientId) &&
            x.chatMembers.includes(this.$store.state.storeAuth.user.uid)
        ).id;
      } catch (error) {
        //console.log(error);
      }

      if (this.chat.online) {
        this.chat.icon = "mdi-forum";
        this.chat.closeButtonText = this.$t(
          "homeMenuCartInfoCloseChatButtonTitle"
        );
      } else {
        this.chat.icon = "mdi-email-send-outline";
        this.chat.emailMsg = "";
        this.chat.closeButtonText = this.$t("lmBtnSend");
      }
      this.chatWindow = true;
    },
    closeChat() {
      //console.log(this.chat.online);
      this.chatWindow = false;
    },
    getChatTime(ts) {
      return moment.unix(ts.seconds).format("HH:mm");
    },
    async handleEnter() {
      try {
        let cDate = new Date();
        await this.$store
          .dispatch("addRoom", {
            client: this.$store.state.storeClient.client.basicSettings.name,
            userId: this.$store.state.storeAuth.user.uid,
            userFullName: this.$store.state.storeAuth.userProfile.fullName,
            recipientId: this.chat.recipientId,
            lastModified: cDate,
            chatMembers: [
              this.$store.state.storeAuth.user.uid,
              this.chat.recipientId,
            ],
            messages: [
              {
                customer: true,
                text: this.chat.message,
                timestamp: cDate,
              },
            ],
          })
          .then(() => {
            this.chat.message = "";
            // dobimo id sobe, da jo potem lahko izbrišemo
            this.chat.roomId = this.$store.state.storeRoom.rooms.find(
              (x) =>
                x.chatMembers.includes(this.chat.recipientId) &&
                x.chatMembers.includes(this.$store.state.storeAuth.user.uid)
            ).id;
          });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
      }
    },
    async handleModeratorEnter() {
      try {
        let cDate = new Date();
        await this.$store
          .dispatch("addRoom", {
            client: this.$store.state.storeClient.client.basicSettings.name,
            userId: this.chat.recipientId,
            recipientId: this.$store.state.storeAuth.user.uid,
            lastModified: cDate,
            chatMembers: [
              this.$store.state.storeAuth.user.uid,
              this.chat.recipientId,
            ],
            messages: [
              {
                customer: false,
                text: this.chat.message,
                timestamp: cDate,
              },
            ],
          })
          .then(() => {
            this.chat.message = "";
          });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
      }
    },
    async deleteRoom() {
      this.dialogWait = true;
      try {
        await this.$store.dispatch("deleteRoom", this.chat.roomId).then(() => {
          this.dialogWait = false;
          this.chat.message = "";
          this.chatWindow = false;
          this.chatModeratorWindow = false;
          this.$store.state.storeRoom.rooms.length <= 0
            ? (this.overlay2 = false)
            : (this.overlay2 = true);
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
      }
    },
    sendEmailMsg(item) {
      return new Promise((resolve, reject) => {
        console.log(item);
        this.chatWindow = false;

        let msgObj = {
          client: this.$store.state.storeClient.client.basicSettings.name,
          recipientEmail: this.chat.recipientEmail,
          senderFullName: this.$store.state.storeAuth.userProfile.fullName,
          senderEmail:
            this.$store.state.storeClient.client.environmentSettings
              .autoResponseEmail,
          senderSubject:
            this.$t("homeMenuCartInfoSendEmailSubjectTitle") +
            this.$store.state.storeAuth.userProfile.fullName +
            " (" +
            this.$store.state.storeAuth.userProfile.email +
            ")",
          senderBody: this.chat.emailMsg,
        };

        let sendFunctionEmailMsg = firebase
          .functions()
          .httpsCallable("sendRealEmailMsg");
        sendFunctionEmailMsg(msgObj)
          .then((res) => {
            if (res.data == "OK") {
              this.$store.commit({
                type: "showSnackbar",
                color: "success",
                message: this.$t("homeMenuCartInfoSendEmailSuccessTitle"),
              });
            } else {
              this.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: this.$t("homeMenuCartInfoSendEmailErrorTitle"),
              });
            }
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });
    },
  },
};
</script>
